import CustomColorIconSvg from 'assets/images/custom-color-icon.svg';

export const colorPickerStyle = {
    colorPicker: {
        background: `url(${CustomColorIconSvg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        width: '50px',
        height: '50px',
        marginTop: '5px',
        position: 'relative',
        '& .MuiInputBase-input': {
            opacity: 0,
            visibility: 'hidden',
        },
        '& .MuiFormControl-root + div': {
            position: 'unset !important',
        },
        '& .MuiFormControl-root + div > div': {
            bottom: '62px',
            right: '-100px',
        },
    },
    colorSwatch: {
        width: '17px',
        height: '17px',
        marginLeft: '20px',
        marginTop: '10px',
        borderRadius: '50%',
    },
    colorMenuItem: {
        marginLeft: '10px',
        marginTop: '10px',
    },
    colorPickerSwatchItems: {
        ml: 1.5,
        display: 'flex',
        alignItems: 'center',
    },
    colorContainer: {
        display: 'flex',
    },
    formStyle: { mt: 1, minWidth: 280 },
    colorPickerFieldSet: { display: 'none' },
};
export interface SelectChangeEvent {
    target: {
        value: string;
    };
}
